<cb-table
    class="cb-margin-top"
    label="Trade Types"
    [objectColumns]="columns"
    [loaded]="loaded"
    [minWidth]="1000"
    [maxHeightOffset]="271"
>
    <tbody cbTableBody>
        @for (tradeType of orderTradeTypes(tradeTypes); track tradeType) {
            <tr>
                <td>
                    @if (tradeType.mappedChildren?.length > 0) {
                        <button
                            mat-icon-button
                            (click)="expanded[tradeType.id] = !expanded[tradeType.id]"
                        >
                            <mat-icon>
                                {{ expanded[tradeType.id] ? 'arrow_drop_up' : 'arrow_drop_down' }}
                            </mat-icon>
                        </button>
                    }
                </td>
                <td>
                    {{ tradeType.label }}
                    @if (!tradeType.isActive) {
                        <span> &nbsp;(Inactive) </span>
                    }
                </td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <cb-td-checkbox [value]="tradeType.isActive"></cb-td-checkbox>
                <td cbTableStickyCol="end" cbTableShrinkCol>
                    <button
                        mat-icon-button
                        (click)="editTradeType(tradeType)"
                        [disabled]="!permissions?.canEdit()"
                    >
                        <mat-icon> edit </mat-icon>
                    </button>
                </td>
            </tr>
            @if (expanded[tradeType.id]) {
                @for (child of orderTradeTypes(tradeType?.filteredChildren); track child) {
                    <tr class="child">
                        <td></td>
                        <td class="childLabel">
                            {{ child.label }}
                        </td>
                        @if (child.requiredComplianceRegistrations.length > 0) {
                            <td>
                                <ul class="inline-list">
                                    @for (
                                        complianceReg of child.requiredComplianceRegistrations;
                                        track complianceReg
                                    ) {
                                        <li>
                                            {{ complianceReg.label }}
                                        </li>
                                    }
                                </ul>
                            </td>
                        }
                        @if (child.requiredComplianceRegistrations.length < 1) {
                            <td>-</td>
                        }
                        <cb-td-checkbox [value]="child.includeInLiveSchedule"></cb-td-checkbox>
                        <cb-td-checkbox [value]="child.canRequestSevenDayPayments"></cb-td-checkbox>
                        <cb-td-checkbox [value]="child.isActive"></cb-td-checkbox>
                        <td cbTableStickyCol="end" cbTableShrinkCol>
                            <button mat-icon-button (click)="editTradeType(child)">
                                <mat-icon> edit </mat-icon>
                            </button>
                        </td>
                    </tr>
                }
            }
        }
    </tbody>
</cb-table>
